import { questionnaireGql } from '../../../gql-gen/questionnaire'

export const DRAFT_CONJOINT_ITEM = questionnaireGql(/* GraphQL */ `
  fragment DraftConjointItem on DraftConjointItem {
    __typename
    questionTypeCode
    question {
      ...Question
    }
    questionMedia {
      ...QuestionMedia
    }
    attributes {
      attributeId
      name
      position
      isAppearance
      options {
        attributeOptionId
        position
        value
        allowedPackages
        media {
          mediaName
          mediaUrl
          mediaType
          renderedMediaUrl
          mediaId
        }
      }
    }
    questionLogic {
      ...DraftLogicClauseProposition
    }
    settingValues {
      code
      value
      createdDate
      sinceDate
    }
    translations {
      language
      text
      textStyling
    }
    attributeTranslations {
      attributeId
      language
      name
      options {
        attributeOptionId
        value
      }
    }
    localeTranslations {
      country
      translation {
        language
        text
        textStyling
      }
    }
    localeAttributeTranslations {
      country
      translation {
        attributeId
        language
        name
        options {
          attributeOptionId
          value
        }
      }
    }
  }
`)
